import { Alert, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useAppContext } from '../../contexts/AppContext';
import { useFieldValue } from '../../hooks/useFormValues';
import type { FieldComponentProps } from '../form-engine/types';

const DatesMismatchWarning = ({ field }: FieldComponentProps) => {
  const { role } = useAppContext();
  const biasCorrection = useFieldValue('rain_operational.bias_correction');

  // An unset toggle ('') defaults to enabled, like the backend.
  // Ex-post analysis never bias-corrects the TMY, so the warning always applies there.
  const enabled = biasCorrection === '' || Boolean(biasCorrection);
  if (enabled && role !== 'ex_post_analysis') {
    return null;
  }

  return (
    <Grid size={field.size || 12}>
      <Alert severity="warning">
        <Typography variant="body2">
          If the dates do not match, the system will automatically replace or supplement your data with NASA data to ensure consistency with
          the timeframe of the chosen soiling ratio curve.
        </Typography>
      </Alert>
    </Grid>
  );
};

export default DatesMismatchWarning;
